import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import CustomerBankAccountDummyRepository
  from './infrastructure/repositories/customer-bank-account-dummy-repository/customer-bank-account-dummy-repository';
import CustomerBankAccountHttpRepository from './infrastructure/repositories/customer-bank-account-http-repository';
import VueStateManager from './infrastructure/state/vue-state-manager';

// Application
import UpdateCustomerBankAccountCommand from './application/commands/update-customer-bank-account-command';
import CustomerBankAccountChooseYourDocumentsService
  from './application/services/customer-bank-account-choose-your-documents-service';

// Domain
import { CustomerBankAccountRepository } from './domain/repositories/customer-bank-account-repository';
import { StateManager } from './domain/state/state-manager';

export default function setupCustomerBankAccount(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<CustomerBankAccountRepository>(TYPES.CUSTOMER_BANK_ACCOUNT_REPOSITORY)
    .to(
      withDummies
        ? CustomerBankAccountDummyRepository
        : CustomerBankAccountHttpRepository,
    ).inSingletonScope();

  container
    .bind<UpdateCustomerBankAccountCommand>(TYPES.UPDATE_CUSTOMER_BANK_ACCOUNT_COMMAND)
    .to(UpdateCustomerBankAccountCommand)
    .inSingletonScope();

  container
    .bind<StateManager>(TYPES.CUSTOMER_BANK_ACCOUNT_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<CustomerBankAccountChooseYourDocumentsService>(TYPES
      .CUSTOMER_BANK_ACCOUNT_CHOOSE_YOUR_DOCUMENTS_SERVICE)
    .to(CustomerBankAccountChooseYourDocumentsService)
    .inSingletonScope();
}
